import {useState, useRef} from "react"
import debounce from 'lodash/debounce';

const SearchDebounceBar = () => {

    const [searchTerm, setSearchTerm] = useState<string>('')
    const [searchTermDebounced, setSearchTermDebounced] = useState<string>('')

    const debounceCall = useRef(debounce( term => {
        setSearchTermDebounced(term)
        }, 800
    )).current
    
    const onDebounce = (term: string) => { debounceCall(term) }

    return {searchTerm, setSearchTerm, searchTermDebounced, onDebounce}
}

export default SearchDebounceBar